/**
 * Shared layout + field styles for lead/checkout flows.
 * Brand: sky (#0284c7) + blue-600 (#2563eb) + teal (#0d9488) — matches App.css / scrollbar gradient.
 */

export const brandFormPage =
  'relative min-h-[100dvh] bg-gradient-to-br from-sky-50 via-blue-50 to-teal-50 px-4 py-10 text-gray-900';

/** Subtle grid for a more “product” / premium feel (very light, stays on-brand). */
export const brandFormMesh =
  'pointer-events-none absolute inset-0 opacity-[0.22] bg-[linear-gradient(to_right,rgb(14_165_233_/_0.12)_1px,transparent_1px),linear-gradient(to_bottom,rgb(14_165_233_/_0.12)_1px,transparent_1px)] bg-[size:28px_28px]';

export const brandFormAmbient =
  'pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_90%_75%_at_50%_30%,rgba(255,255,255,0.72)_0%,transparent_55%)]';

export const brandFormCard =
  'overflow-hidden rounded-2xl border border-blue-100/90 bg-white/95 shadow-xl shadow-blue-900/10 backdrop-blur-sm';

export const brandFormAccentBar = 'h-1.5 w-full bg-gradient-to-r from-blue-600 via-sky-500 to-teal-600';

export const brandFormHeaderBand =
  'border-b border-blue-100/80 bg-gradient-to-b from-white via-sky-50/35 to-teal-50/20 px-5 py-4 sm:px-6 sm:py-5';

export const brandFormInput =
  'w-full rounded-xl border border-slate-200/90 bg-white/95 px-3.5 py-2.5 text-[15px] text-gray-900 shadow-sm shadow-slate-200/40 placeholder:text-slate-400 transition ' +
  'focus:border-sky-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-sky-300/45 focus:ring-offset-0';

export const brandFormLabel = 'text-[11px] font-semibold uppercase tracking-wide text-slate-600';

export const brandFormLabelInline = 'text-[11px] font-medium text-slate-600';

export const brandFormSectionKicker = 'text-[10px] font-semibold uppercase tracking-[0.14em] text-slate-500';

export const brandFormPrimaryCta =
  'w-full rounded-full border border-transparent bg-gradient-to-r from-blue-600 via-sky-500 to-teal-600 py-6 text-base font-semibold text-white shadow-lg shadow-blue-900/20 ' +
  'transition hover:from-blue-700 hover:via-sky-600 hover:to-teal-700 hover:shadow-xl hover:shadow-teal-900/10 disabled:opacity-70';

export const brandFormFooterBand =
  'border-t border-blue-100/80 bg-gradient-to-r from-slate-50/90 via-sky-50/30 to-teal-50/25 px-5 py-4 text-center sm:px-6';
